import { modelList, saveFavorite, showFavorite, deleteFavorite } from '@/utils/mysqTools'
import { getInfo } from '@/api/user'
const state = {
  model_list: [],
  favorite_list: [],
  back: null,
  userInfo: {
    // 用户信息
    userName: '',
    userId: ''
  }
}

const mutations = {
  // 公共模型列表
  setModelList(state, val) {
    val.forEach(element => {
      const obj = {
        id: element[0],
        modelType: element[1],
        modelName: element[2],
        modelCover: element[3],
        ckptname: element[4],
        loraname: element[5],
        modelUse: element[6],
        visible: true,
        width: element[8],
        height: element[9],
        steps: element[10],
        guidance: element[11],
        weight: element[12],
        cfg: element[13],
        default_tips: element[14],
        english: element[15],
        chinese: element[16],
        galleryname: element[17],
        currentData: element[18]
      }
      const exists = state.model_list.some(item => item.id === obj.id)
      if (!exists) {
        state.model_list.push(obj)
      }
    })
  },
  // 收藏的列表
  setFavorite(state, data) {
    state.favorite_list = []
    data.forEach(element => {
      const obj = {
        id: element[0],
        userName: element[1],
        userId: element[2],
        modelType: element[3],
        modelName: element[4],
        modelCover: element[5],
        ckptname: element[6],
        loraname: element[7],
        modelUse: element[8],
        visible: true,
        width: element[10],
        height: element[11],
        steps: element[12],
        guidance: element[13],
        weight: element[14],
        cfg: element[15],
        default_tips: element[16],
        english: element[17],
        chinese: element[18],
        galleryname: element[19],
        currentData: element[20]
      }
      const exists = state.favorite_list.some(item => item.id === obj.id)
      if (!exists) {
        state.favorite_list.push(obj)
      }
    })
  }
}

const getters = {
  sourceModelList(state) {
    return state.model_list.filter(item => item.id !== 6)
  },
  sourceFavoriteList(state) {
    return state.favorite_list
  }
}

const actions = {
  // 获取用户信息
  getUserInfo: async (context) => {
    const userInfo = await getInfo()
    context.state.userInfo.userName = userInfo.data.user.basic.c_name
    context.state.userInfo.userId = userInfo.data.user.basic.id
  },
  async getModelList(context) {
    const res = await modelList()
    context.commit('setModelList', res.tables)
  },
  async getFavoriteList(context) {
    const params = {
      userId: state.userInfo.userId
    }
    const table = await showFavorite(params)
    context.commit('setFavorite', table.tables)
  },
  // 收藏
  async saveMyFavorite(context, data) {
    let formattedDate = data.currentData
    if (data.currentData) {
      const date = new Date(data.currentData)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      formattedDate = `${year}-${month}-${day}`
    }
    const params = {
      id: Number(String(data.id) + String(state.userInfo.userId)),
      userName: context.state.userInfo.userName,
      userId: context.state.userInfo.userId,
      modelType: data.modelType,
      modelName: data.modelName,
      modelCover: data.modelCover,
      ckptname: data.ckptname,
      loraname: data.loraname,
      modelUse: data.modelUse,
      visible: true,
      width: data.width,
      height: data.height,
      steps: data.steps,
      guidance: data.guidance,
      weight: data.weight,
      cfg: data.cfg,
      default_tips: data.default_tips,
      english: data.english,
      chinese: data.chinese,
      galleryname: data.galleryname,
      currentData: formattedDate
    }
    const back = await saveFavorite(params)
    state.back = back.result
  },
  // 删除收藏
  async deleteMyFavorite(context, data) {
    const params = {
      userId: state.userInfo.userId,
      id: data
    }
    await deleteFavorite(params)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
